import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import { format } from "date-fns";
import PortalSidebar, { usePortalTab } from "../PortalSidebar/PortalSidebar";

// Base URL for all API calls
const API_BASE = "https://portal.gmacc.co.za/api";
//const API_BASE = "http://127.0.0.1:8000/api";

/* ────────── Speciality Options (unchanged) ────────── */
const SPECIALITY_OPTIONS = [
  { label: "Armed Response", value: 121510012 },
  { label: "Association", value: 121510021 },
  { label: "Attorney", value: 156310001 },
  { label: "Brokers", value: 121510015 },
  { label: "Building", value: 121510001 },
  { label: "CSOS", value: 156310003 },
  { label: "Electrical", value: 121510000 },
  { label: "Facility Management", value: 121510022 },
  { label: "Fibre", value: 121510008 },
  { label: "Fire Equipment Servicing", value: 121510013 },
  { label: "Gardening / Landscaping", value: 121510003 },
  { label: "General", value: 121510007 },
  { label: "Guards", value: 121510011 },
  { label: "Insurance Companies", value: 121510014 },
  { label: "Municipal Account", value: 156310002 },
  { label: "Painting", value: 121510005 },
  { label: "Paving", value: 121510009 },
  { label: "Pest Control", value: 121510004 },
  { label: "Plumbing", value: 121510002 },
  { label: "Prepaid Providers", value: 121510017 },
  { label: "Property Valuations", value: 121510020 },
  { label: "Roofing", value: 121510018 },
  { label: "Rubble Removal", value: 121510023 },
  { label: "Security", value: 121510006 },
  { label: "Signage", value: 121510019 },
  { label: "Structural Engineer", value: 121510024 },
  { label: "Technical Installers", value: 121510016 },
  { label: "Waterproofing", value: 121510010 },
];
const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#6b7280"
    viewBox="0 0 24 24"
    style={{ marginRight: "6px" }}
  >
    <path d="M12 1a5 5 0 00-5 5v4H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2v-9a2 2 0 00-2-2h-2V6a5 5 0 00-5-5zm-3 9V6a3 3 0 116 0v4H9z" />
  </svg>
);

/* ────────── (kept) simple lists you already had ────────── */
const BANK_NAME_OPTIONS = [
  "Absa",
  "Access Bank",
  "African Bank",
  "Albaraka Bank",
  "Bank of Athens",
  "Barclays Bank",
  "Bidvest Bank",
  "Capitec Bank",
  "Capitec Business",
  "Discovery Bank",
  "First National Bank",
  "FirstRand Bank",
  "HSBC Bank",
  "Investec",
  "Mercantile Bank",
  "Nedbank",
  "Old Mutual",
  "Rand Merchant Bank",
  "RMB Private Bank",
  "Sasfin Bank Limited",
  "South African Post Bank",
  "Standard Bank",
  "Standard Chartered Bank",
  "Tyme Bank",
];
const ACCOUNT_TYPE_OPTIONS = ["Current (Main)", "Reserve", "Savings", "Trust"];

/* ────────── NEW authoritative select sources ────────── */
const ACCOUNT_TYPE_SELECT = [
  { label: "Current (Main)", value: 121510000 },
  { label: "Reserve", value: 121510001 },
  { label: "Savings", value: 121510002 },
  { label: "Trust", value: 121510003 },
];

const BANKS = [
  { name: "Absa", id: "6aec65c3-3254-ed11-bba2-000d3adf7aa1" },
  { name: "Access Bank", id: "a1355640-b177-ee11-8179-000d3adf7aa1" },
  { name: "African Bank", id: "35769190-5d4a-ee11-be6f-000d3adea7d6" },
  { name: "Albaraka Bank", id: "45d610f1-eea3-ee11-bbfe-000d3adf7aa1" },
  { name: "Bank of Athens", id: "5b0f53c7-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Barclays Bank", id: "bf0567-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Bidvest Bank", id: "da4164ab-2356-ed11-bba2-000d3adf7aa1" },
  { name: "Capitec Bank", id: "7a0e0bbe-2256-ed11-bba2-000d3adf7aa1" },
  { name: "Capitec Business", id: "6b0a7bec-cee8-ee11-a569-000d3adf7aa1" },
  { name: "Discovery Bank", id: "aaa8062e-20c1-ee11-8179-000d3adf7aa1" },
  { name: "First National Bank", id: "5773f52c-3534-ed11-bba2-000d3adf79f4" },
  { name: "FirstRand Bank", id: "6ac5173a-8f50-ee11-be6e-000d3adf79f4" },
  { name: "HSBC Bank", id: "8020507f-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Investec", id: "68727213-2356-ed11-bba2-000d3adf79f4" },
  { name: "Mercantile Bank", id: "49175085-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Nedbank", id: "31cd3060-3534-ed11-bba2-000d3adf79f4" },
  { name: "Old Mutual", id: "91549f1f-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Rand Merchant Bank", id: "643a02b0-8f50-ee11-be6e-000d3adf79f4" },
  { name: "RMB Private Bank", id: "a5d3a0b2-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Sasfin Bank Limited", id: "fa9e83e8-8f50-ee11-be6e-000d3adf79f4" },
  {
    name: "South African Post Bank",
    id: "a3e6b193-3354-ed11-bba2-000d3adf7aa1",
  },
  { name: "Standard Bank", id: "c12293b9-434e-ee11-be6e-000d3adea7d6" },
  {
    name: "Standard Chartered Bank",
    id: "1936b984-54d4-ee11-bee4-000d3adea7d6",
  },
  { name: "Tyme Bank", id: "2a5b8c2a-65aa-ee11-bee4-000d3adea7d6" },
];

/* ────────── Tab Selector (unchanged) ────────── */
const TabSelector = ({ tabs, active, onChange }) => (
  <div className={styles.tabSelector}>
    {tabs.map((tab) => (
      <div
        key={tab}
        className={active === tab ? styles.activeTab : styles.inactiveTab}
        onClick={() => onChange(tab)}
      >
        {tab}
      </div>
    ))}
  </div>
);

/* ────────── Helpers (unchanged) ────────── */
const formatAmount = (amt) => {
  const n = Number(amt) || 0;
  const [int, dec] = n.toFixed(2).split(".");
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, "\u2002") + "," + dec;
};
const formatDate = (raw, fmt = "dd MMM yyyy HH:mm") => {
  if (!raw) return "";

  const d = new Date(raw);

  if (isNaN(d.getTime())) return "";

  // Ignore Unix epoch / empty Dataverse dates
  if (d.getFullYear() <= 1970) return "";

  return format(d, fmt);
};
const norm = (s) => (s ?? "").toString().toLowerCase();
const contains = (hay, needle) => norm(hay).includes(norm(needle));
const getLegalBuildingName = (f) =>
  f?.cj_Account?.[
    "_cj_linkedbuilding_value@OData.Community.Display.V1.FormattedValue"
  ] || "";
const getQuoteBuildingName = (q) =>
  q?.cj_MaintenanceJobAssignment?.[
    "_cj_building_value@OData.Community.Display.V1.FormattedValue"
  ] || "";
const getJobBuildingName = (j) =>
  j?.["_cj_building_value@OData.Community.Display.V1.FormattedValue"] || "";
const getPaymentBuildingName = (p) =>
  p?.[
    "_cr446_specifybuilding_value@OData.Community.Display.V1.FormattedValue"
  ] || "";
const getPaymentDateRaw = (item) =>
  item?.cj_paymenttime || item?.createdon || null;
const toDayStart = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
const toDayEnd = (d) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

/* ⭐ NEW: progress code filter for requested quotes */
const MAINTENANCE_PROGRESS_REQUESTED = 121510010;
/** Try to extract a numeric progress code from a maintenance-like row */
const getProgressCode = (row) => {
  const candidates = [
    row?.cj_progress,
    row?.cj_Progress,
    row?.progress,
    row?.["cj_progress"],
  ];
  for (const c of candidates) {
    if (typeof c === "number") return c;
    if (typeof c === "string" && /^\d+$/.test(c)) return parseInt(c, 10);
  }
  return null;
};

/* ────────── Pagination (unchanged) ────────── */
const Pagination = ({ currentPage, setCurrentPage, total, perPage }) => {
  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(start + perPage - 1, total);
  const pages = Math.ceil(total / perPage);
  return (
    <div className={styles.pagination}>
      <button
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
      <span className={styles.pageMeta}>
        {start}–{end} of {total}
      </span>
      <button
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === pages}
      >
        Next
      </button>
    </div>
  );
};

/* ────────── MultiSelectDropdown (unchanged) ────────── */
const MultiSelectDropdown = ({ options, selected, onChange }) => {
  const sel = Array.isArray(selected) ? selected : [];
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((o) => !o);
  const handleCheckbox = (value) => {
    if (sel.includes(value)) onChange(sel.filter((v) => v !== value));
    else onChange([...sel, value]);
  };
  const display = sel.length
    ? options
        .filter((o) => sel.includes(o.value))
        .map((o) => o.label)
        .join(", ")
    : "Select…";
  return (
    <div className={styles.multiSelect}>
      <button
        type="button"
        className={styles.multiSelectButton}
        onClick={toggle}
      >
        {display} <span className={styles.dropdownArrow}></span>
      </button>
      {open && (
        <div className={styles.multiSelectList}>
          {options.map((opt) => (
            <label key={opt.value} className={styles.multiSelectOption}>
              <input
                type="checkbox"
                checked={sel.includes(opt.value)}
                onChange={() => handleCheckbox(opt.value)}
              />
              {opt.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default function ContractorPortalPage() {
  const navigate = useNavigate();
  const contactId = localStorage.getItem("contact_id");

  /* ─── State (unchanged + additions) ─── */
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  const [contractorId, setContractorId] = useState(null);
  const [generalData, setGeneralData] = useState(null);
  const [loadingId, setLoadingId] = useState(true);
  const [errorId, setErrorId] = useState(null);

  const [activeTab, setActiveTab] = usePortalTab("contractor");
  const perPage = 10;
  const [legalFiles, setLegalFiles] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [payments, setPayments] = useState([]);
  const [bcAccounts, setBcAccounts] = useState([]);
  const [loadingBcAccounts, setLoadingBcAccounts] = useState(false);
  const [errorBcAccounts, setErrorBcAccounts] = useState(null);
  const [bcAccountsPage, setBcAccountsPage] = useState(1);
  const [bcAccountsBuildingQuery, setBcAccountsBuildingQuery] = useState("");

  // ⬇️ UPDATED: sub-tabs include "Requested"
  const [quotesSubTab, setQuotesSubTab] = useState("Current");
  const [quotesCurrent, setQuotesCurrent] = useState([]);
  const [quotesHistorical, setQuotesHistorical] = useState([]);

  // NEW: Requested quotes (maintenance records awaiting a quote)
  const [requestedQuotes, setRequestedQuotes] = useState([]);

  const [loadingLegal, setLoadingLegal] = useState(false);
  const [loadingQuotes, setLoadingQuotes] = useState(false);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(false);

  // NEW: loading + error for requested
  const [loadingRequested, setLoadingRequested] = useState(false);

  const [errorLegal, setErrorLegal] = useState(null);
  const [errorQuotes, setErrorQuotes] = useState(null);
  const [errorJobs, setErrorJobs] = useState(null);
  const [errorPayments, setErrorPayments] = useState(null);

  // NEW: error for requested
  const [errorRequested, setErrorRequested] = useState(null);

  const [legalPage, setLegalPage] = useState(1);
  const [quotePage, setQuotePage] = useState(1);
  const [jobPage, setJobPage] = useState(1);
  const [paymentPage, setPaymentPage] = useState(1);

  const [legalBuildingQuery, setLegalBuildingQuery] = useState("");
  const [quotesBuildingQuery, setQuotesBuildingQuery] = useState("");
  const [jobsBuildingQuery, setJobsBuildingQuery] = useState("");
  const [paymentsBuildingQuery, setPaymentsBuildingQuery] = useState("");
  const [paymentDateFrom, setPaymentDateFrom] = useState("");
  const [paymentDateTo, setPaymentDateTo] = useState("");
  const [paymentsReferenceQuery, setPaymentsReferenceQuery] = useState("");

  const [hasCompanyDoc, setHasCompanyDoc] = useState(false);
  const [hasBankDoc, setHasBankDoc] = useState(false);
  const [beneficiaryId, setBeneficiaryId] = useState(null);

  const [editState, setEditState] = useState({
    emailaddress: "",
    cj_companytelephone: "",
    cj_contractorspeciality: [],
    cj_registrationnumber: "",
    cj_vatnumber: "",
  });
  const [proofFile, setProofFile] = useState(null);
  const [loadingSave, setLoadingSave] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);

  /* NEW: modal + beneficiary details */
  const [bankProofFile, setBankProofFile] = useState(null);
  const [beneficiaryForm, setBeneficiaryForm] = useState({
    account_name: "",
    bank_name: "", // GUID
    account_number: "",
    account_type: "", // INT
  });
  const [beneficiaryModalOpen, setBeneficiaryModalOpen] = useState(false);
  const [beneficiaryModalError, setBeneficiaryModalError] = useState("");

  /* ────────── NEW: Upload Quote Modal state ────────── */
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null); // the maintenance record row
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadAmount, setUploadAmount] = useState("");
  const [uploadSubmitting, setUploadSubmitting] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const [legalUpdateModalOpen, setLegalUpdateModalOpen] = useState(false);
  const [legalPaymentModalOpen, setLegalPaymentModalOpen] = useState(false);
  const [selectedLegal, setSelectedLegal] = useState(null);
  const [legalEditFields, setLegalEditFields] = useState({
    letter_of_demand: "",
    summons_sent_to_court: "",
    summons_served: "",
    warrant_of_execution: "",
    judgement: "",
    judgement_granted: "",
    section65: "",
    section66: "",
    aod_start_date: "",
    aod_end_date: "",
    aod_amount: "",
    active_attorney_aod: "",
    current_situation: "",
    nulla_bonna: "",
    attachment: "",
    rule46_application: "",
  });
  const [originalLegalEditFields, setOriginalLegalEditFields] = useState({});

  const requiresLegalInvoice = (legal) =>
    legal?.requires_legal_invoice === true;

  const [legalPaymentForm, setLegalPaymentForm] = useState({
    file: null,
    amount: "",
    invoice: "",
    invoiceDate: "",
  });
  const [legalAodFile, setLegalAodFile] = useState(null);
  const [legalModalSaving, setLegalModalSaving] = useState(false);
  const [legalModalError, setLegalModalError] = useState("");
  const [legalModalSuccess, setLegalModalSuccess] = useState("");
  const toYMD = (v) => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d)) return "";
    return d.toISOString().slice(0, 10);
  };
  const [selectedLegalIds, setSelectedLegalIds] = useState([]);
  const [batchMode, setBatchMode] = useState(false);
  /* Filters (unchanged) */
  const sortedLegalFiles = useMemo(() => {
    return [...legalFiles].sort((a, b) =>
      (a.cr446_textaccountnumber || "").localeCompare(
        b.cr446_textaccountnumber || "",
      ),
    );
  }, [legalFiles]);
  const legalFilesFiltered = useMemo(() => {
    const q = norm(legalBuildingQuery);
    if (!q) return sortedLegalFiles;
    return sortedLegalFiles.filter((f) => contains(getLegalBuildingName(f), q));
  }, [sortedLegalFiles, legalBuildingQuery]);
  const bcAccountsFiltered = useMemo(() => {
    const query = norm(bcAccountsBuildingQuery);

    if (!query) return bcAccounts;

    return bcAccounts.filter(
      (account) =>
        contains(account.building_name, query) ||
        contains(account.vendor_code, query),
    );
  }, [bcAccounts, bcAccountsBuildingQuery]);

  useEffect(() => {
    setBcAccountsPage(1);
  }, [bcAccountsBuildingQuery]);

  useEffect(() => {
    if (activeTab !== "My Accounts" || !contractorId) return;

    const controller = new AbortController();

    const loadBcAccounts = async () => {
      setLoadingBcAccounts(true);
      setErrorBcAccounts(null);

      try {
        const token = localStorage.getItem("token");

        const response = await fetch(
          `${API_BASE}/contractor-id/${contractorId}/bc-accounts/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
          },
        );

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            data.error || "Failed to load Business Central accounts.",
          );
        }

        setBcAccounts(Array.isArray(data.value) ? data.value : []);
      } catch (error) {
        if (error.name !== "AbortError") {
          setErrorBcAccounts(error.message);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoadingBcAccounts(false);
        }
      }
    };

    loadBcAccounts();

    return () => controller.abort();
  }, [activeTab, contractorId]);

  const currentPageLegalRows = legalFilesFiltered.slice(
    (legalPage - 1) * perPage,
    legalPage * perPage,
  );

  const selectedLegalRows = legalFiles.filter((f) =>
    selectedLegalIds.includes(f.cj_legalid),
  );

  const toggleLegalSelection = (legalId) => {
    setSelectedLegalIds((prev) =>
      prev.includes(legalId)
        ? prev.filter((id) => id !== legalId)
        : [...prev, legalId],
    );
  };

  const toggleSelectCurrentPage = () => {
    const pageIds = currentPageLegalRows
      .map((f) => f.cj_legalid)
      .filter(Boolean);
    const allSelected = pageIds.every((id) => selectedLegalIds.includes(id));

    setSelectedLegalIds((prev) =>
      allSelected
        ? prev.filter((id) => !pageIds.includes(id))
        : [...new Set([...prev, ...pageIds])],
    );
  };

  const initLegalModalFields = (leg) => {
    const nullaFmt =
      leg?.["cr446_nullabonna@OData.Community.Display.V1.FormattedValue"];
    const nullaBool =
      typeof leg?.cr446_nullabonna === "boolean"
        ? leg.cr446_nullabonna
          ? "Yes"
          : "No"
        : "";

    const attachmentFmt =
      leg?.["cr446_attachment@OData.Community.Display.V1.FormattedValue"];
    const attachmentBool =
      typeof leg?.cr446_attachment === "boolean"
        ? leg.cr446_attachment
          ? "Yes"
          : "No"
        : "";
    const fields = {
      letter_of_demand: toYMD(leg?.cr446_letterofdemand),
      summons_sent_to_court: toYMD(leg?.cr446_summonssenttocourt),
      summons_served: toYMD(leg?.cj_summonsserved),
      warrant_of_execution: toYMD(leg?.cr446_warrantofexecution),
      judgement:
        leg?.["cr446_judgement@OData.Community.Display.V1.FormattedValue"] ||
        (typeof leg?.cr446_judgement === "boolean"
          ? leg.cr446_judgement
            ? "Yes"
            : "No"
          : ""),
      judgement_granted: toYMD(leg?.cj_judgementgranted),
      section65: toYMD(leg?.cj_section65),
      section66: toYMD(leg?.cj_section66),
      aod_start_date: toYMD(leg?.cj_attorneyaodstartdate),
      aod_end_date: toYMD(leg?.cj_aodenddate),
      aod_amount: leg?.cj_aodamount ?? "",
      active_attorney_aod:
        leg?.[
          "cr446_activeattorneyaod@OData.Community.Display.V1.FormattedValue"
        ] ||
        (typeof leg?.cr446_activeattorneyaod === "boolean"
          ? leg.cr446_activeattorneyaod
            ? "Yes"
            : "No"
          : ""),
      current_situation: leg?.cj_currentsituationdescription ?? "",
      nulla_bonna: nullaFmt || nullaBool || "",
      attachment: attachmentFmt || attachmentBool || "",
      rule46_application: toYMD(leg?.cr446_rule46application),
    };

    setLegalEditFields(fields);
    setOriginalLegalEditFields(fields);
  };

  const openLegalUpdateModal = async (legalRow = null) => {
    setLegalModalError("");
    setLegalModalSuccess("");
    setLegalAodFile(null);

    const rows = legalRow ? [legalRow] : selectedLegalRows;

    if (!rows.length) {
      setLegalModalError("Please select at least one legal file.");
      return;
    }

    setBatchMode(rows.length > 1);

    const first = rows[0];
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const res = await fetch(`${API_BASE}/legals/${first.cj_legalid}/`, {
        headers,
      });

      const fullLegal = res.ok ? await res.json() : first;

      setSelectedLegal(rows.length === 1 ? fullLegal : rows);
      initLegalModalFields(rows.length === 1 ? fullLegal : {});
      setLegalUpdateModalOpen(true);
    } catch {
      setSelectedLegal(rows.length === 1 ? first : rows);
      initLegalModalFields(rows.length === 1 ? first : {});
      setLegalUpdateModalOpen(true);
    }
  };

  const openLegalPaymentModal = (legalRow = null) => {
    const rows = legalRow ? [legalRow] : selectedLegalRows;

    if (!rows.length) {
      setLegalModalError("Please select at least one legal file.");
      return;
    }

    setBatchMode(rows.length > 1);
    setLegalModalError("");
    setLegalModalSuccess("");
    setLegalPaymentForm({
      file: null,
      amount: "",
      invoice: "",
      invoiceDate: "",
    });
    setSelectedLegal(rows.length === 1 ? rows[0] : rows);
    setLegalPaymentModalOpen(true);
  };

  const handleLegalModalSaveDetails = async () => {
    const rows = Array.isArray(selectedLegal) ? selectedLegal : [selectedLegal];
    if (!rows.length) return;

    setLegalModalSaving(true);
    setLegalModalError("");
    setLegalModalSuccess("");

    try {
      const token = localStorage.getItem("token");

      const payload = Object.fromEntries(
        Object.entries(legalEditFields).filter(([key, value]) => {
          const originalValue = originalLegalEditFields[key];

          return String(value ?? "") !== String(originalValue ?? "");
        }),
      );

      if (!payload.current_situation || !payload.current_situation.trim()) {
        delete payload.current_situation;
      }

      if (payload.aod_amount !== "" && !isNaN(payload.aod_amount)) {
        payload.aod_amount = Number(payload.aod_amount);
      } else {
        delete payload.aod_amount;
      }

      ["active_attorney_aod", "judgement", "nulla_bonna", "attachment"].forEach(
        (key) => {
          if (payload[key] === "Yes") payload[key] = true;
          else if (payload[key] === "No") payload[key] = false;
          else delete payload[key];
        },
      );

      const results = await Promise.allSettled(
        rows.map(async (row) => {
          if (Object.keys(payload).length > 0) {
            const res = await fetch(
              `${API_BASE}/legal/${row.cj_legalid}/update/`,
              {
                method: "PATCH",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              },
            );

            if (!res.ok) {
              throw new Error(await res.text());
            }
          }
          if (legalAodFile) {
            const fd = new FormData();
            fd.append("file", legalAodFile, legalAodFile.name);

            const up = await fetch(
              `${API_BASE}/legal/${row.cj_legalid}/upload/aod-file/`,
              {
                method: "PATCH",
                headers: { Authorization: `Bearer ${token}` },
                body: fd,
              },
            );

            if (!up.ok) throw new Error(await up.text());
          }
        }),
      );

      const failed = results.filter((r) => r.status === "rejected").length;

      setLegalModalSuccess(
        failed
          ? `${rows.length - failed} updated, ${failed} failed.`
          : `${rows.length} legal file(s) updated.`,
      );

      await refreshLegalFiles();
    } catch (e) {
      setLegalModalError(e.message || "Failed to save legal details.");
    } finally {
      setLegalModalSaving(false);
    }
  };

  const handleLegalModalSubmitPayment = async () => {
    const rows = Array.isArray(selectedLegal) ? selectedLegal : [selectedLegal];

    if (!rows.length || !rows[0]) return;

    const { file, amount, invoice, invoiceDate } = legalPaymentForm;

    const containsInvoiceRows = rows.some(requiresLegalInvoice);
    const containsPaymentRows = rows.some((row) => !requiresLegalInvoice(row));

    if (!file || !amount || !invoice) {
      setLegalModalError("Please choose a file, amount, and invoice number.");
      return;
    }

    if (containsInvoiceRows && !invoiceDate) {
      setLegalModalError(
        "Invoice date is required for the selected invoice case(s).",
      );
      return;
    }

    setLegalModalSaving(true);
    setLegalModalError("");
    setLegalModalSuccess("");

    try {
      const token = localStorage.getItem("token");

      const userProfileId =
        localStorage.getItem("userProfileId") ||
        (() => {
          try {
            const decoded = JSON.parse(atob(token.split(".")[1] || ""));
            return decoded?.user_profile_id || "";
          } catch {
            return "";
          }
        })();

      const results = await Promise.allSettled(
        rows.map(async (row) => {
          const formData = new FormData();

          formData.append("file", file);
          formData.append("amount", amount);
          formData.append("invoice", invoice);

          if (containsInvoiceRows) {
            formData.append("invoiceDate", invoiceDate);
          }

          if (userProfileId) {
            formData.append("userProfileId", userProfileId);
          }

          const response = await fetch(
            `${API_BASE}/legal/${row.cj_legalid}/submit-payment/`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            },
          );

          if (!response.ok) {
            throw new Error(await response.text());
          }
        }),
      );

      const failed = results.filter(
        (result) => result.status === "rejected",
      ).length;

      const modeLabel =
        containsInvoiceRows && containsPaymentRows
          ? "payment/invoice"
          : containsInvoiceRows
            ? "invoice"
            : "payment";

      setLegalPaymentForm({
        file: null,
        amount: "",
        invoice: "",
        invoiceDate: "",
      });

      setLegalModalSuccess(
        failed
          ? `${rows.length - failed} ${modeLabel} submission(s) loaded, ${failed} failed.`
          : `${rows.length} ${modeLabel} submission(s) loaded.`,
      );

      await refreshLegalFiles();
    } catch (error) {
      setLegalModalError(
        error.message || "Failed to load the legal submission.",
      );
    } finally {
      setLegalModalSaving(false);
    }
  };

  // Endpoint: POST with FormData {file, amount}
  const buildUploadQuoteEndpoint = (maintenanceId) =>
    `${API_BASE}/maintenance/${maintenanceId}/submit-quote/`;

  /* Inline input style you already use */
  const inputStyle = {
    background: "transparent",
    border: "1px solid #444",
    borderRadius: "4px",
    color: "white",
    padding: "4px 8px",
    width: "100%",
    boxSizing: "border-box",
  };

  const darkSelectStyle = {
    ...inputStyle,
    background: "#0f162c",
    color: "#e9eefc",
  };
  const optionStyle = { background: "#0f162c", color: "#e9eefc" };
  const [displayName, setDisplayName] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Default sidebar state based on device width
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);

      // Only force closed when moving to smaller screens.
      // On desktop, keep whatever state the user last chose.
      if (!desktop) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    function handleClick(e) {
      // On desktop/laptop, only the burger should control the sidebar
      if (isDesktop) return;

      const sidebar = document.getElementsByClassName(styles.sidebar)[0];
      const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

      if (!sidebar || !hamburger) return;

      const clickedInsideSidebar = sidebar.contains(e.target);
      const clickedHamburger = hamburger.contains(e.target);

      if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
        setSidebarOpen(false);
      }
    }

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [sidebarOpen, isDesktop]);

  /* Access (unchanged) */
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
              ? name
              : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          },
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  /* Contractor id + base general data (unchanged) */
  useEffect(() => {
    (async () => {
      setLoadingId(true);
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${API_BASE}/contractor-id/${contactId}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error();
        const { contractorId: c } = await res.json();
        setContractorId(c.cj_contractorid);
        setGeneralData(c);
      } catch {
        setErrorId("Could not determine your contractor record.");
      } finally {
        setLoadingId(false);
      }
    })();
  }, [contactId, navigate]);

  /* Seed edit state (unchanged) */
  useEffect(() => {
    if (!generalData) return;
    const raw = generalData.cj_contractorspeciality;
    const cleaned =
      typeof raw === "string" ? raw.replace(/[\s\[\]]/g, "") : raw;
    const initialSpecialities = Array.isArray(raw)
      ? raw
      : typeof cleaned === "string"
        ? cleaned
            .split(",")
            .map((s) => parseInt(s, 10))
            .filter((n) => !isNaN(n))
        : [];
    setEditState({
      emailaddress: generalData.emailaddress || "",
      cj_companytelephone: generalData.cj_companytelephone || "",
      cj_contractorspeciality: initialSpecialities,
      cj_registrationnumber: generalData.cj_registrationnumber || "",
      cj_vatnumber: generalData.cj_vatnumber || "",
    });
    setBeneficiaryId(generalData["_cj_beneficiary_value"]);
  }, [generalData]);

  const hasBeneficiary = Boolean(
    generalData && generalData["_cj_beneficiary_value"],
  );

  const handleBankProofChange = (e) => {
    if (e.target.files?.[0]) setBankProofFile(e.target.files[0]);
  };

  const refreshLegalFiles = async () => {
    if (!contractorId) return;

    setLoadingLegal(true);
    setErrorLegal(null);

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const res = await fetch(
        `${API_BASE}/contractor-id/${contractorId}/legals/`,
        { headers },
      );

      if (!res.ok) throw new Error();

      const data = await res.json();
      const legalRows = data.value || data;

      setLegalFiles(Array.isArray(legalRows) ? legalRows : []);
    } catch {
      setErrorLegal("Failed to load legal files");
    } finally {
      setLoadingLegal(false);
    }
  };

  useEffect(() => {
    refreshLegalFiles();
  }, [contractorId]);

  /* Check document existence (unchanged behavior) */
  useEffect(() => {
    if (!contractorId) return;
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    fetch(`${API_BASE}/contractor-id/${contractorId}/download/registration/`, {
      method: "GET",
      headers,
    })
      .then((r) => setHasCompanyDoc(r.ok))
      .catch(() => setHasCompanyDoc(false));

    if (generalData?._cj_beneficiary_value) {
      fetch(
        `${API_BASE}/contractor-id/${generalData._cj_beneficiary_value}/download/bank-proof/`,
        { method: "GET", headers },
      )
        .then((r) => setHasBankDoc(r.ok))
        .catch(() => setHasBankDoc(false));
    } else {
      setHasBankDoc(false);
    }
  }, [contractorId, generalData?._cj_beneficiary_value]);

  /* Fetch other tabs (unchanged) */
  useEffect(() => {
    if (!contractorId) return;
    if (activeTab === "My Quotes") return;

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const endpoints = {
      "My Jobs": ["maintenance", setJobs, setLoadingJobs, setErrorJobs],
      "My Payments": [
        "payments",
        setPayments,
        setLoadingPayments,
        setErrorPayments,
      ],
    };
    if (endpoints[activeTab]) {
      const [path, setter, loadSetter, errSetter] = endpoints[activeTab];
      loadSetter(true);
      fetch(`${API_BASE}/contractor-id/${contractorId}/${path}/`, { headers })
        .then((r) => (r.ok ? r.json() : Promise.reject()))
        .then((data) => setter(data.value || data))
        .catch(() => errSetter(`Failed to load ${activeTab.toLowerCase()}`))
        .finally(() => loadSetter(false));
    }
  }, [activeTab, contractorId]);

  /* Quotes + NEW Requested subtab loader */
  useEffect(() => {
    if (activeTab !== "My Quotes" || !contractorId) return;
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const loadCurrent = async () => {
      if (quotesCurrent.length) {
        setQuotes(quotesCurrent);
        return;
      }
      setLoadingQuotes(true);
      setErrorQuotes(null);
      try {
        const r = await fetch(
          `${API_BASE}/contractor-id/${contractorId}/quotes/`,
          { headers },
        );
        if (!r.ok) throw new Error();
        const data = await r.json();
        const val = data.value || data;
        console.log("Current:", val); // handle OData vs plain
        setQuotesCurrent(val);
        setQuotes(val);
      } catch {
        setErrorQuotes("Failed to load current quotes");
      } finally {
        setLoadingQuotes(false);
      }
    };

    const loadHistorical = async () => {
      if (quotesHistorical.length) {
        setQuotes(quotesHistorical);
        return;
      }
      setLoadingQuotes(true);
      setErrorQuotes(null);
      try {
        const r = await fetch(
          `${API_BASE}/contractor-id/${contractorId}/historicalquotes/`,
          { headers },
        );
        if (!r.ok) throw new Error();
        const data = await r.json();
        const val = data.value || data;
        setQuotesHistorical(val);
        setQuotes(val);
      } catch {
        setErrorQuotes("Failed to load historical quotes");
      } finally {
        setLoadingQuotes(false);
      }
    };

    const loadRequested = async () => {
      setLoadingRequested(true);
      setErrorRequested(null);

      try {
        // Fetch requested items (Maintenance)
        const r = await fetch(
          `${API_BASE}/contractor/${contractorId}/requested-quotes/`,
          { headers },
        );
        const dataReq = await r.json();
        const requested = dataReq.value || dataReq;

        // Fetch existing quotes
        const qRes = await fetch(
          `${API_BASE}/contractor-id/${contractorId}/quotes/`,
          { headers },
        );
        const dataQ = await qRes.json();
        const quotes = dataQ.value || dataQ;

        // Create a set of quoted maintenance GUIDs
        const quotedIds = new Set(
          quotes
            .map((q) => q._cj_maintenancejobassignment_value)
            .filter(Boolean),
        );

        // Mark requested items as already quoted
        const enriched = requested.map((row) => ({
          ...row,
          __quoteUploaded: quotedIds.has(row.cj_maintenancebid),
        }));

        setRequestedQuotes(enriched);
      } catch (e) {
        console.error("Requested-load error:", e);
        setErrorRequested("Failed to load requested quotes");
      } finally {
        setLoadingRequested(false);
      }
    };

    if (quotesSubTab === "Current") loadCurrent();
    else if (quotesSubTab === "Historical") loadHistorical();
    else if (quotesSubTab === "Requested") loadRequested();
  }, [
    activeTab,
    contractorId,
    quotesSubTab,
    quotesCurrent.length,
    quotesHistorical.length,
  ]);

  /* Tabs list (unchanged) */
  const displayTabs = useMemo(() => {
    const base = ["General", "My Accounts"];

    if (legalFiles.length) {
      base.push("Legal Files");
    }

    return [...base, "My Quotes", "My Jobs", "My Payments"];
  }, [legalFiles]);

  /* Beneficiary validations */
  const mustFillBeneficiaryDetails = Boolean(
    bankProofFile && !hasBeneficiary && !hasBankDoc,
  );
  const beneficiaryFieldsMissing =
    mustFillBeneficiaryDetails &&
    (!beneficiaryForm.account_name ||
      !beneficiaryForm.bank_name ||
      !beneficiaryForm.account_number ||
      !beneficiaryForm.account_type);

  /* Save General (unchanged + beneficiary handling) */
  const handleGeneralSave = async (e) => {
    e.preventDefault();
    setLoadingSave(true);
    setSaveError(null);
    setSaveSuccess(false);

    try {
      if (beneficiaryFieldsMissing) {
        throw new Error(
          "Please complete Bank Account details (Account Name, Bank Name, Account Number, Account Type) before saving.",
        );
      }

      const token = localStorage.getItem("token");
      const specString = editState.cj_contractorspeciality.join(",");

      // 1) Save editable contractor metadata
      const patchRes = await fetch(
        `${API_BASE}/contractor-id/${contractorId}/update`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cj_contractorid: contractorId,
            emailaddress: editState.emailaddress,
            cj_companytelephone: editState.cj_companytelephone,
            cj_contractorspeciality: specString,
            cj_registrationnumber: editState.cj_registrationnumber,
            cj_vatnumber: editState.cj_vatnumber,
          }),
        },
      );
      if (!patchRes.ok)
        throw new Error(`Metadata update failed: ${await patchRes.text()}`);

      // 2) Upload company registration doc if provided
      if (proofFile) {
        const uploadRes = await fetch(
          `${API_BASE}/contractor-id/${contractorId}/upload/registration/`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/octet-stream",
              "x-ms-file-name": proofFile.name,
            },
            body: proofFile,
          },
        );
        if (!uploadRes.ok)
          throw new Error(`File upload failed: ${await uploadRes.text()}`);
        setHasCompanyDoc(true);
      }

      // 3) Beneficiary proof handling
      if (bankProofFile) {
        if (!hasBeneficiary) {
          const fd = new FormData();
          fd.append("beneficiary_name", beneficiaryForm.account_name);
          fd.append("bank_id", beneficiaryForm.bank_name);
          fd.append("account_number", beneficiaryForm.account_number);
          fd.append("account_type", String(beneficiaryForm.account_type));
          fd.append("file", bankProofFile, bankProofFile.name);

          const makeBen = await fetch(
            `${API_BASE}/contractor/${contractorId}/beneficiary/`,
            {
              method: "POST",
              headers: { Authorization: `Bearer ${token}` },
              body: fd,
            },
          );

          if (!makeBen.ok && makeBen.status !== 207) {
            throw new Error(await makeBen.text());
          }
          const res = await makeBen.json().catch(() => ({}));
          const newBenId = res?.beneficiary_id;
          if (newBenId) {
            setBeneficiaryId(newBenId);
            setGeneralData((g) => ({ ...g, _cj_beneficiary_value: newBenId }));
          }
          setHasBankDoc(res?.file_uploaded === true);
          if (res?.file_uploaded === false) {
            throw new Error(res?.file_error || "Bank proof upload failed.");
          }
        } else {
          const fd2 = new FormData();
          fd2.append("file", bankProofFile, bankProofFile.name);

          const up = await fetch(
            `${API_BASE}/beneficiary/${beneficiaryId}/upload/bank-proof/`,
            {
              method: "PATCH",
              headers: { Authorization: `Bearer ${token}` },
              body: fd2,
            },
          );
          if (!up.ok) throw new Error(await up.text());
          setHasBankDoc(true);
        }
      }

      setSaveSuccess(true);
    } catch (err) {
      setSaveError(err.message);
    } finally {
      setLoadingSave(false);
    }
  };

  const handleProofChange = (e) => {
    if (e.target.files?.[0]) setProofFile(e.target.files[0]);
  };

  const quotesFiltered = useMemo(() => {
    const q = norm(quotesBuildingQuery);
    if (!q) return quotes;
    return quotes.filter((row) => contains(getQuoteBuildingName(row), q));
  }, [quotes, quotesBuildingQuery]);

  const jobsFiltered = useMemo(() => {
    const q = norm(jobsBuildingQuery);
    if (!q) return jobs;
    return jobs.filter((row) => contains(getJobBuildingName(row), q));
  }, [jobs, jobsBuildingQuery]);

  const paymentsFiltered = useMemo(() => {
    const buildingQuery = norm(paymentsBuildingQuery).trim();
    const referenceQuery = norm(paymentsReferenceQuery).trim();

    const from = paymentDateFrom ? toDayStart(paymentDateFrom) : null;
    const to = paymentDateTo
      ? toDayEnd(paymentDateTo)
      : paymentDateFrom
        ? toDayEnd(paymentDateFrom)
        : null;

    return payments.filter((row) => {
      const buildingOk = buildingQuery
        ? contains(getPaymentBuildingName(row), buildingQuery)
        : true;

      const referenceOk = referenceQuery
        ? contains(row?.cr446_theirreference, referenceQuery)
        : true;

      if (!buildingOk || !referenceOk) {
        return false;
      }

      if (!from && !to) {
        return true;
      }

      const rawDate = getPaymentDateRaw(row);

      if (!rawDate) {
        return false;
      }

      const paymentDate = new Date(rawDate);

      if (isNaN(paymentDate.getTime())) {
        return false;
      }

      const afterFrom = from ? paymentDate >= from : true;
      const beforeTo = to ? paymentDate <= to : true;

      return afterFrom && beforeTo;
    });
  }, [
    payments,
    paymentsBuildingQuery,
    paymentsReferenceQuery,
    paymentDateFrom,
    paymentDateTo,
  ]);

  // ⭐ UPDATED: Requested list filter (progress == 121510010, then apply building search)
  const requestedFiltered = useMemo(() => {
    const q = norm(quotesBuildingQuery);
    const base = Array.isArray(requestedQuotes)
      ? requestedQuotes.filter(
          (row) => getProgressCode(row) === MAINTENANCE_PROGRESS_REQUESTED,
        )
      : [];
    if (!q) return base;
    return base.filter((row) => contains(getJobBuildingName(row), q));
  }, [requestedQuotes, quotesBuildingQuery]);

  /* Reset pages on filter changes (unchanged + requested) */
  useEffect(() => {
    setLegalPage(1);
  }, [legalBuildingQuery, sortedLegalFiles.length]);
  useEffect(() => {
    setQuotePage(1);
  }, [
    quotesBuildingQuery,
    quotes.length,
    quotesSubTab,
    requestedQuotes.length,
  ]);
  useEffect(() => {
    setJobPage(1);
  }, [jobsBuildingQuery, jobs.length]);
  useEffect(() => {
    setPaymentPage(1);
  }, [
    paymentsBuildingQuery,
    paymentsReferenceQuery,
    paymentDateFrom,
    paymentDateTo,
    payments.length,
  ]);

  /* ────────── Upload Quote Modal handlers ────────── */
  const openUploadModal = (row) => {
    setUploadTarget(row);
    setUploadFile(null);
    setUploadAmount("");
    setUploadError("");
    setUploadModalOpen(true);
  };

  const closeUploadModal = () => {
    setUploadModalOpen(false);
    setUploadTarget(null);
    setUploadFile(null);
    setUploadAmount("");
    setUploadError("");
  };

  // small helper to consistently derive the maintenance key
  const getMaintenanceKey = (row) =>
    row?.cj_maintenancebid || row?.cj_maintenanceid || row?.id;

  const handleUploadSave = async () => {
    try {
      if (!uploadTarget) {
        setUploadError("No record selected.");
        return;
      }
      if (!uploadFile) {
        setUploadError("Please select a PDF file.");
        return;
      }
      if (!uploadAmount || isNaN(Number(uploadAmount))) {
        setUploadError("Please enter a valid amount.");
        return;
      }

      setUploadSubmitting(true);
      setUploadError("");

      const key = getMaintenanceKey(uploadTarget);
      const url = buildUploadQuoteEndpoint(key);
      const token = localStorage.getItem("token");

      const fd = new FormData();
      fd.append("file", uploadFile, uploadFile.name);
      fd.append("amount", String(uploadAmount));
      fd.append("contractor_guid", contractorId);

      // ── Optimistic UI: mark as submitted immediately
      setRequestedQuotes((prev) =>
        prev.map((r) =>
          getMaintenanceKey(r) === key
            ? {
                ...r,
                __quoteUploaded: true,
                __quoteAmount: Number(uploadAmount),
              }
            : r,
        ),
      );

      const res = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });

      if (!res.ok) {
        const t = await res.text();
        // revert optimistic flag on failure
        setRequestedQuotes((prev) =>
          prev.map((r) =>
            getMaintenanceKey(r) === key
              ? { ...r, __quoteUploaded: false, __quoteAmount: undefined }
              : r,
          ),
        );
        throw new Error(t || "Upload failed");
      }

      // On success, we keep the optimistic state and close the modal
      closeUploadModal();
    } catch (e) {
      setUploadError(e.message || "Could not submit quote.");
    } finally {
      setUploadSubmitting(false);
    }
  };

  const shouldShowField = (value) => {
    if (value === null || value === undefined) return true;

    if (typeof value === "string") {
      return value.trim() === "";
    }

    return false;
  };

  const legalSubmissionRows = selectedLegal
    ? Array.isArray(selectedLegal)
      ? selectedLegal
      : [selectedLegal]
    : [];

  const hasInvoiceSubmissionRows =
    legalSubmissionRows.some(requiresLegalInvoice);

  const hasPaymentSubmissionRows = legalSubmissionRows.some(
    (row) => !requiresLegalInvoice(row),
  );

  const legalSubmissionLabel =
    hasInvoiceSubmissionRows && hasPaymentSubmissionRows
      ? "Payment / Invoice"
      : hasInvoiceSubmissionRows
        ? "Invoice"
        : "Payment";

  /* Render */
  return (
    <div classname={styles.page}>
      {/* NAVBAR */}
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>CONTRACTOR PORTAL</h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <div className={styles.shell}>
        <PortalSidebar
          activePortal="contractor"
          activeTab={activeTab}
          onTabChange={setActiveTab}
          userAccess={userAccess}
          loadingAccess={loadingAccess}
          sidebarOpen={sidebarOpen}
          hiddenTabKeys={legalFiles.length > 0 ? [] : ["legal-files"]}
          ticketRole={null}
        />

        <main className={styles.contentArea}>
          <div className={styles.panel}>
            <div className={styles.card}>
              {/* GENERAL TAB (unchanged) */}
              {activeTab === "General" &&
                (loadingId ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorId ? (
                  <p className={styles.errorText}>{errorId}</p>
                ) : (
                  generalData && (
                    <form
                      onSubmit={handleGeneralSave}
                      className={styles.contractorProfileCard}
                    >
                      {[
                        ["Company Name", generalData.cj_name, false],
                        ["Trading As", generalData.cr446_tradingas, false],
                        [
                          "Abbreviation",
                          generalData.cj_contractorabbreviation,
                          false,
                        ],

                        [
                          "Email",
                          editState.emailaddress,
                          true,
                          (val) => (
                            <input
                              type="email"
                              value={val}
                              onChange={(e) =>
                                setEditState((s) => ({
                                  ...s,
                                  emailaddress: e.target.value,
                                }))
                              }
                              className={styles.profileInput}
                            />
                          ),
                        ],

                        [
                          "Phone",
                          editState.cj_companytelephone,
                          true,
                          (val) => (
                            <input
                              type="text"
                              value={val}
                              onChange={(e) =>
                                setEditState((s) => ({
                                  ...s,
                                  cj_companytelephone: e.target.value,
                                }))
                              }
                              className={styles.profileInput}
                            />
                          ),
                        ],

                        [
                          "Speciality",
                          editState.cj_contractorspeciality,
                          true,
                          () => (
                            <MultiSelectDropdown
                              options={SPECIALITY_OPTIONS}
                              selected={editState.cj_contractorspeciality}
                              onChange={(sel) =>
                                setEditState((s) => ({
                                  ...s,
                                  cj_contractorspeciality: sel,
                                }))
                              }
                              className={styles.profileSelect}
                            />
                          ),
                        ],

                        [
                          "Status",
                          generalData[
                            "cj_contractorstatus@OData.Community.Display.V1.FormattedValue"
                          ],
                          false,
                        ],
                        [
                          "Payment Approved",
                          generalData[
                            "cr446_paymentapproved@OData.Community.Display.V1.FormattedValue"
                          ],
                          false,
                        ],
                        [
                          "FICA Approved",
                          generalData[
                            "cr446_ficaapproved@OData.Community.Display.V1.FormattedValue"
                          ],
                          false,
                        ],

                        [
                          "Registration No.",
                          editState.cj_registrationnumber,
                          false,
                        ],

                        [
                          "VAT No.",
                          editState.cj_vatnumber,
                          true,
                          (val) => (
                            <input
                              type="text"
                              value={val}
                              onChange={(e) =>
                                setEditState((s) => ({
                                  ...s,
                                  cj_vatnumber: e.target.value,
                                }))
                              }
                              className={styles.profileInput}
                            />
                          ),
                        ],
                      ].map(([label, value, editable, renderFn]) => (
                        <div key={label} className={styles.profileRow}>
                          <div className={styles.profileLabel}>{label}</div>
                          <div>
                            {editable ? (
                              renderFn ? (
                                renderFn(value)
                              ) : null
                            ) : (
                              <div className={styles.profileValue}>
                                <span className={styles.profileIconLock}>
                                  <LockIcon />{" "}
                                </span>
                                {value ?? "—"}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}

                      <div className={styles.profileButtonRow}>
                        {/* COMPANY REG DOC BUTTON */}
                        {hasCompanyDoc ? (
                          <a
                            href={`${API_BASE}/contractor-id/${contractorId}/download/registration/`}
                            download="contractor_reg_doc.pdf"
                            className={styles.profileSaveBtn}
                          >
                            Download Company Reg. Doc
                          </a>
                        ) : (
                          <label className={styles.profileSaveBtn}>
                            <input
                              type="file"
                              onChange={handleProofChange}
                              className={styles.fileHidden}
                            />
                            Upload Company Reg. Doc
                          </label>
                        )}

                        {/* BANK PROOF BUTTON */}
                        {hasBankDoc ? (
                          <a
                            href={`${API_BASE}/contractor-id/${generalData["_cj_beneficiary_value"]}/download/bank-proof/`}
                            download="contractor_bankproof.pdf"
                            className={styles.profileSaveBtn}
                          >
                            Download Bank Account Document
                          </a>
                        ) : (
                          <button
                            className={styles.profileSaveBtn}
                            type="button"
                            onClick={() => {
                              setBeneficiaryModalError("");
                              setBeneficiaryModalOpen(true);
                            }}
                          >
                            Upload Bank Account Document
                          </button>
                        )}

                        {/* SAVE BUTTON */}
                        <button
                          className={styles.profileSaveBtn}
                          type="submit"
                          disabled={loadingSave || beneficiaryFieldsMissing}
                        >
                          {loadingSave ? "Saving…" : "Save Changes"}
                        </button>
                      </div>

                      {saveError && (
                        <p className={styles.errorText}>{saveError}</p>
                      )}
                      {saveSuccess && (
                        <p className={styles.successText}>
                          Saved successfully!
                        </p>
                      )}
                    </form>
                  )
                ))}

              {/* MY ACCOUNTS */}
              {activeTab === "My Accounts" &&
                (loadingBcAccounts ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading accounts...</p>
                  </div>
                ) : errorBcAccounts ? (
                  <p className={styles.errorText}>{errorBcAccounts}</p>
                ) : !bcAccounts.length ? (
                  <p className={styles.infoText}>
                    No Business Central vendor accounts were found for your
                    buildings.
                  </p>
                ) : (
                  <>
                    <div className={styles.whiteFiltersRow}>
                      <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by building or vendor code…"
                        value={bcAccountsBuildingQuery}
                        onChange={(event) =>
                          setBcAccountsBuildingQuery(event.target.value)
                        }
                      />

                      {bcAccountsBuildingQuery && (
                        <button
                          type="button"
                          className={styles.whiteClearButton}
                          onClick={() => setBcAccountsBuildingQuery("")}
                        >
                          Clear
                        </button>
                      )}
                    </div>

                    <div className={styles.maintp}>
                      <p>
                        Select an account to view its Business Central vendor
                        ledger.
                      </p>
                    </div>

                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Building Name</th>
                            <th>Vendor Code</th>
                            <th>Balance</th>
                          </tr>
                        </thead>

                        <tbody>
                          {bcAccountsFiltered
                            .slice(
                              (bcAccountsPage - 1) * perPage,
                              bcAccountsPage * perPage,
                            )
                            .map((account) => (
                              <tr
                                key={account.building_id}
                                className={styles.bcClickableRow}
                                onClick={() =>
                                  navigate(
                                    `/contractor-accounts/${contractorId}/${account.building_id}`,
                                  )
                                }
                              >
                                <td>{account.building_name}</td>
                                <td>{account.vendor_code}</td>
                                <td>
                                  <span className={styles.bcCurrencyAmount}>
                                    <span>R</span>
                                    <span>{formatAmount(account.balance)}</span>
                                  </span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    <Pagination
                      currentPage={bcAccountsPage}
                      setCurrentPage={setBcAccountsPage}
                      total={bcAccountsFiltered.length}
                      perPage={perPage}
                    />
                  </>
                ))}

              {/* LEGAL FILES (unchanged) */}
              {activeTab === "Legal Files" &&
                legalFiles.length > 0 &&
                (loadingLegal ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorLegal ? (
                  <p className={styles.errorText}>{errorLegal}</p>
                ) : (
                  <>
                    <div className={styles.whiteFiltersRow}>
                      <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by building name…"
                        value={legalBuildingQuery}
                        onChange={(e) => setLegalBuildingQuery(e.target.value)}
                      />
                      {legalBuildingQuery ? (
                        <button
                          className={styles.whiteClearButton}
                          onClick={() => setLegalBuildingQuery("")}
                          type="button"
                        >
                          Clear
                        </button>
                      ) : null}
                    </div>
                    {selectedLegalIds.length > 0 && (
                      <div
                        className={styles.whiteFiltersRow}
                        style={{ justifyContent: "space-between" }}
                      >
                        <span>
                          {selectedLegalIds.length} legal file(s) selected
                        </span>

                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          <button
                            type="button"
                            className={styles.profileSaveBtn}
                            onClick={() => openLegalUpdateModal()}
                          >
                            Update Selected
                          </button>

                          <button
                            type="button"
                            className={styles.whiteClearButton}
                            onClick={() => setSelectedLegalIds([])}
                          >
                            Clear Selection
                          </button>
                        </div>
                      </div>
                    )}
                    <div className={styles.maintp}>
                      <p>All legal files assigned to you.</p>
                    </div>
                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  currentPageLegalRows.length > 0 &&
                                  currentPageLegalRows.every((f) =>
                                    selectedLegalIds.includes(f.cj_legalid),
                                  )
                                }
                                onChange={toggleSelectCurrentPage}
                              />
                            </th>
                            <th>Account Number</th>
                            <th>File Name</th>
                            <th>Attorney</th>
                            <th>Progress</th>
                            <th>Type</th>
                            <th>Debt On Handover</th>
                            <th>Next Follow Up</th>
                            <th>Building</th>
                            <th>Current Situation Last Updated</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {legalFilesFiltered
                            .slice(
                              (legalPage - 1) * perPage,
                              legalPage * perPage,
                            )
                            .map((f) => (
                              <tr key={f.annotationid || f.id}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedLegalIds.includes(
                                      f.cj_legalid,
                                    )}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      toggleLegalSelection(f.cj_legalid);
                                    }}
                                  />
                                </td>
                                <td>
                                  {
                                    f[
                                      "_cj_account_value@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(
                                      `/contractor-legal/${f.cj_legalid}/${contractorId}`,
                                    )
                                  }
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "none")
                                  }
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                >
                                  {f.cj_name || f.name}
                                </td>
                                <td>
                                  {f[
                                    " _cj_attorney_value@OData.Community.Display.V1.FormattedValue"
                                  ] ||
                                    f[
                                      "_cj_attorney_value@OData.Community.Display.V1.FormattedValue"
                                    ]}
                                </td>
                                <td>
                                  {
                                    f[
                                      "cj_progress@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  {
                                    f[
                                      "cr446_legaltype@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  <span className={styles.amountCell}>
                                    {formatAmount(f.cj_debtonhandover)}
                                  </span>
                                </td>
                                <td>{formatDate(f.cj_nextfollowupdate)}</td>
                                <td>{getLegalBuildingName(f)}</td>
                                <td>
                                  {f.currentSituationLastUpdated
                                    ? formatDate(f.currentSituationLastUpdated)
                                    : "—"}
                                </td>

                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <button
                                      className={styles.profileSaveBtn}
                                      type="button"
                                      onClick={() => openLegalPaymentModal(f)}
                                    >
                                      {requiresLegalInvoice(f)
                                        ? "Load Invoice"
                                        : "Load Payment"}
                                    </button>

                                    <button
                                      className={styles.profileSaveBtn}
                                      type="button"
                                      onClick={() => openLegalUpdateModal(f)}
                                    >
                                      Update
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={legalPage}
                      setCurrentPage={setLegalPage}
                      total={legalFilesFiltered.length}
                      perPage={perPage}
                    />
                  </>
                ))}

              {/* MY QUOTES (UPDATED: new Requested subtab) */}
              {activeTab === "My Quotes" && (
                <>
                  <div className={styles.subTabs}>
                    <div
                      className={
                        quotesSubTab === "Current"
                          ? styles.subTabActive
                          : styles.subTab
                      }
                      onClick={() => setQuotesSubTab("Current")}
                    >
                      Current
                    </div>
                    <div
                      className={
                        quotesSubTab === "Requested"
                          ? styles.subTabActive
                          : styles.subTab
                      }
                      onClick={() => setQuotesSubTab("Requested")}
                    >
                      Requested
                    </div>
                    <div
                      className={
                        quotesSubTab === "Historical"
                          ? styles.subTabActive
                          : styles.subTab
                      }
                      onClick={() => setQuotesSubTab("Historical")}
                    >
                      Historical
                    </div>
                  </div>

                  {/* Shared filter row */}
                  <div className={styles.whiteFiltersRow}>
                    <input
                      className={styles.searchInput}
                      type="text"
                      placeholder="Search by building name…"
                      value={quotesBuildingQuery}
                      onChange={(e) => setQuotesBuildingQuery(e.target.value)}
                    />
                    {quotesBuildingQuery ? (
                      <button
                        className={styles.whiteClearButton}
                        onClick={() => setQuotesBuildingQuery("")}
                        type="button"
                      >
                        Clear
                      </button>
                    ) : null}
                  </div>

                  {/* Current/Historical original tables */}
                  {(quotesSubTab === "Current" ||
                    quotesSubTab === "Historical") &&
                    (loadingQuotes ? (
                      <div className={styles.loadingContainer}>
                        <div className={styles.loadingImage}></div>
                        <p className={styles.loadingText}>Loading...</p>
                      </div>
                    ) : errorQuotes ? (
                      <p className={styles.errorText}>{errorQuotes}</p>
                    ) : !quotes.length ? (
                      <p className={styles.infoText}>No quotes.</p>
                    ) : (
                      <>
                        <div className={styles.maintp}>
                          {quotesSubTab === "Current" && (
                            <p>
                              All active maintenance jobs for which you have
                              submitted quotes, and which have not yet been
                              awarded to any contractor.
                            </p>
                          )}

                          {quotesSubTab === "Historical" && (
                            <p>
                              All past maintenance jobs where you submitted
                              quotes, and the job has been awarded to you.
                            </p>
                          )}
                        </div>

                        <div className={styles.responsiveTableWrapper}>
                          <table className={styles.dataTable}>
                            <thead>
                              <tr>
                                <th>Quote Name</th>
                                <th>Maintenance Job</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Building</th>
                              </tr>
                            </thead>
                            <tbody>
                              {quotesFiltered
                                .slice(
                                  (quotePage - 1) * perPage,
                                  quotePage * perPage,
                                )
                                .map((q) => (
                                  <tr key={q.cj_quoteid || q.id}>
                                    <td>
                                      {q.cj_quotelink ? (
                                        <a
                                          href={q.cj_quotelink}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {q.cj_name}
                                        </a>
                                      ) : (
                                        "—"
                                      )}
                                    </td>
                                    <td>
                                      {
                                        q[
                                          "_cj_maintenancejobassignment_value@OData.Community.Display.V1.FormattedValue"
                                        ]
                                      }
                                    </td>
                                    <td>
                                      <span className={styles.amountCell}>
                                        {formatAmount(
                                          q?.cj_amount ?? q?.amount ?? 0,
                                        )}
                                      </span>
                                    </td>
                                    <td>
                                      {
                                        q[
                                          "cj_approvalstatus@OData.Community.Display.V1.FormattedValue"
                                        ]
                                      }
                                    </td>
                                    <td>{getQuoteBuildingName(q)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        <Pagination
                          currentPage={quotePage}
                          setCurrentPage={setQuotePage}
                          total={quotesFiltered.length}
                          perPage={perPage}
                        />
                      </>
                    ))}

                  {/* NEW: Requested table */}
                  {quotesSubTab === "Requested" &&
                    (loadingRequested ? (
                      <div className={styles.loadingContainer}>
                        <div className={styles.loadingImage}></div>
                        <p className={styles.loadingText}>Loading...</p>
                      </div>
                    ) : errorRequested ? (
                      <p className={styles.errorText}>{errorRequested}</p>
                    ) : !requestedFiltered.length ? (
                      <p className={styles.infoText}>No requested quotes.</p>
                    ) : (
                      <>
                        <div className={styles.maintp}>
                          <p>
                            All maintenance jobs where you have been asked to
                            submit a quote.
                          </p>
                        </div>
                        <div className={styles.responsiveTableWrapper}>
                          <table className={styles.dataTable}>
                            <thead>
                              <tr>
                                <th>Maintenance Job</th>
                                <th>Description</th>
                                <th>Building</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {requestedFiltered
                                .slice(
                                  (quotePage - 1) * perPage,
                                  quotePage * perPage,
                                )
                                .map((row) => {
                                  const id =
                                    row.cj_maintenancebid ||
                                    row.id ||
                                    row.cj_maintenanceid;
                                  const name =
                                    row.cj_name || row.name || "Maintenance";
                                  const desc =
                                    row.cj_fulldescription ||
                                    row.description ||
                                    "—";
                                  const requestedOn =
                                    row[
                                      "createdon@OData.Community.Display.V1.FormattedValue"
                                    ] ||
                                    row.createdon ||
                                    row.requestedon ||
                                    "—";
                                  const building =
                                    row[
                                      "_cj_building_value@OData.Community.Display.V1.FormattedValue"
                                    ] || "—";
                                  const already = row.__quoteUploaded === true;

                                  return (
                                    <tr key={id}>
                                      <td>{name}</td>
                                      <td>{desc}</td>
                                      <td>{building}</td>
                                      <td>
                                        <button
                                          className={styles.profileSaveBtn}
                                          disabled={already}
                                          onClick={() => openUploadModal(row)}
                                          title={
                                            already
                                              ? "Quote already uploaded"
                                              : "Upload Quote"
                                          }
                                        >
                                          {already
                                            ? "Quote Uploaded"
                                            : "Upload Quote"}
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                        <Pagination
                          currentPage={quotePage}
                          setCurrentPage={setQuotePage}
                          total={requestedFiltered.length}
                          perPage={perPage}
                        />
                      </>
                    ))}
                </>
              )}

              {/* MY JOBS (unchanged) */}
              {activeTab === "My Jobs" &&
                (loadingJobs ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorJobs ? (
                  <p className={styles.errorText}>{errorJobs}</p>
                ) : !jobs.length ? (
                  <p className={styles.infoText}>No jobs.</p>
                ) : (
                  <>
                    <div className={styles.whiteFiltersRow}>
                      <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by building name…"
                        value={jobsBuildingQuery}
                        onChange={(e) => setJobsBuildingQuery(e.target.value)}
                      />
                      {jobsBuildingQuery ? (
                        <button
                          className={styles.whiteClearButton}
                          onClick={() => setJobsBuildingQuery("")}
                          type="button"
                        >
                          Clear
                        </button>
                      ) : null}
                    </div>
                    <div className={styles.maintp}>
                      <p>All maintenance jobs that have been awarded to you.</p>
                    </div>
                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Progress</th>
                            <th>Invoice Amount</th>
                            <th>Building</th>
                            <th>Paid Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {jobsFiltered
                            .slice((jobPage - 1) * perPage, jobPage * perPage)
                            .map((j) => (
                              <tr
                                key={j.cj_maintenancebid || j.id}
                                onClick={() =>
                                  navigate(
                                    `/contractor-maint/${
                                      j.cj_maintenancebid || j.id
                                    }/${contractorId}`,
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <td
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "none")
                                  }
                                >
                                  {j.cj_name}
                                </td>
                                <td>{j.cj_fulldescription}</td>
                                <td>
                                  {j[
                                    "cj_progress@OData.Community.Display.V1.FormattedValue"
                                  ] || j.cj_progress}
                                </td>
                                <td>
                                  <span className={styles.amountCell}>
                                    {formatAmount(j.cj_invoiceamount)}
                                  </span>
                                </td>
                                <td>{getJobBuildingName(j)}</td>
                                <td>
                                  <span className={styles.amountCell}>
                                    {formatAmount(j.cj_sumofpayments)}
                                  </span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={jobPage}
                      setCurrentPage={setJobPage}
                      total={jobsFiltered.length}
                      perPage={perPage}
                    />
                  </>
                ))}

              {/* MY PAYMENTS (unchanged) */}
              {activeTab === "My Payments" &&
                (loadingPayments ? (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingImage}></div>
                    <p className={styles.loadingText}>Loading...</p>
                  </div>
                ) : errorPayments ? (
                  <p className={styles.errorText}>{errorPayments}</p>
                ) : !payments.length ? (
                  <p className={styles.infoText}>No payments.</p>
                ) : (
                  <>
                    <div className={styles.whiteFiltersRow}>
                      <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by building name…"
                        value={paymentsBuildingQuery}
                        onChange={(e) =>
                          setPaymentsBuildingQuery(e.target.value)
                        }
                      />

                      <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by my reference…"
                        value={paymentsReferenceQuery}
                        onChange={(e) =>
                          setPaymentsReferenceQuery(e.target.value)
                        }
                      />

                      <div className={styles.dateFilterWrapper}>
                        <input
                          className={styles.dateInput}
                          type="date"
                          value={paymentDateFrom}
                          onChange={(e) => setPaymentDateFrom(e.target.value)}
                          aria-label="From date"
                        />

                        <span> To </span>

                        <input
                          className={styles.dateInput}
                          type="date"
                          value={paymentDateTo}
                          onChange={(e) => setPaymentDateTo(e.target.value)}
                          aria-label="To date"
                        />
                      </div>

                      {paymentsBuildingQuery ||
                      paymentsReferenceQuery ||
                      paymentDateFrom ||
                      paymentDateTo ? (
                        <button
                          className={styles.whiteClearButton}
                          onClick={() => {
                            setPaymentsBuildingQuery("");
                            setPaymentsReferenceQuery("");
                            setPaymentDateFrom("");
                            setPaymentDateTo("");
                          }}
                          type="button"
                        >
                          Clear
                        </button>
                      ) : null}
                    </div>
                    <div className={styles.maintp}>
                      <p>All payments that have been made to you.</p>
                    </div>
                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Payment Number</th>
                            <th>Amount</th>
                            <th>Payment Type</th>
                            <th>Paid To</th>
                            <th>My Reference</th>
                            <th>Progress</th>
                            <th>Date</th>
                            <th>Building</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentsFiltered
                            .slice(
                              (paymentPage - 1) * perPage,
                              paymentPage * perPage,
                            )
                            .map((item) => {
                              const pType =
                                item[
                                  "cr446_paymenttype@OData.Community.Display.V1.FormattedValue"
                                ];
                              const isMaintenance = pType === "Maintenance";
                              const maintenanceName =
                                item[
                                  "_cj_linkedmaintenancerecord_value@OData.Community.Display.V1.FormattedValue"
                                ];
                              const maintenanceId =
                                item["_cj_linkedmaintenancerecord_value"];
                              const paidToStr =
                                pType === "Account"
                                  ? item[
                                      "_cj_accountt_value@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  : pType === "Municipality"
                                    ? item[
                                        "_cj_municipality_value@OData.Community.Display.V1.FormattedValue"
                                      ]
                                    : item[
                                        "_cr446_contractorname_value@OData.Community.Display.V1.FormattedValue"
                                      ];
                              const progress =
                                item[
                                  "cj_progress@OData.Community.Display.V1.FormattedValue"
                                ];
                              const dateLabel =
                                progress === "Paid"
                                  ? "Payment Date:"
                                  : "Created Date:";
                              const dateVal =
                                progress === "Paid"
                                  ? formatDate(item.cj_paymenttime)
                                  : formatDate(item.createdon);
                              return (
                                <tr key={item.cr446_paymentid}>
                                  <td>{item.cr446_paymentpk}</td>
                                  <td>
                                    <span className={styles.amountCell}>
                                      {formatAmount(item.cr446_amount)}
                                    </span>
                                  </td>
                                  <td>{pType}</td>
                                  <td>
                                    {isMaintenance && maintenanceId ? (
                                      <span
                                        onClick={() =>
                                          navigate(
                                            `/contractor-maint/${maintenanceId}/${contractorId}`,
                                          )
                                        }
                                        onMouseEnter={(e) =>
                                          (e.currentTarget.style.textDecoration =
                                            "underline")
                                        }
                                        onMouseLeave={(e) =>
                                          (e.currentTarget.style.textDecoration =
                                            "none")
                                        }
                                        style={{
                                          cursor: "pointer",
                                          textDecoration: "none",
                                        }}
                                      >
                                        {maintenanceName || "Maintenance Job"}
                                      </span>
                                    ) : (
                                      paidToStr
                                    )}
                                  </td>
                                  <td>{item.cr446_theirreference}</td>
                                  <td
                                    className={
                                      progress === "Paid"
                                        ? styles.paidProgress
                                        : ""
                                    }
                                  >
                                    {progress}
                                  </td>
                                  <td>
                                    {dateLabel} {dateVal}
                                  </td>
                                  <td>{getPaymentBuildingName(item)}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={paymentPage}
                      setCurrentPage={setPaymentPage}
                      total={paymentsFiltered.length}
                      perPage={perPage}
                    />
                  </>
                ))}
            </div>
          </div>
        </main>
      </div>

      {/* ────────── Beneficiary Upload Modal ────────── */}
      {beneficiaryModalOpen && !hasBankDoc && (
        <div
          role="dialog"
          aria-modal="true"
          className={styles.modalOverlay}
          onClick={() => setBeneficiaryModalOpen(false)}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            {/* HEADER */}
            <div className={styles.modalHeaderRow}>
              <h2 className={styles.modalTitle}>UPLOAD BANK ACCOUNT PROOF</h2>
              <button
                className={styles.modalClose}
                type="button"
                onClick={() => setBeneficiaryModalOpen(false)}
              >
                ✕
              </button>
            </div>

            {/* BODY */}
            <div className={styles.modalBody}>
              {/* FILE UPLOAD */}
              <div className={styles.inputGroup}>
                <label>Bank Account Proof (PDF / Image)</label>
                <input
                  type="file"
                  onChange={handleBankProofChange}
                  className={styles.selectPill}
                />
              </div>

              {!hasBeneficiary && (
                <>
                  {/* ACCOUNT NAME */}
                  <div className={styles.inputGroup}>
                    <label>Account Name</label>
                    <input
                      type="text"
                      value={beneficiaryForm.account_name}
                      onChange={(e) =>
                        setBeneficiaryForm((s) => ({
                          ...s,
                          account_name: e.target.value,
                        }))
                      }
                      className={styles.selectPill}
                      placeholder="e.g. ABC Contractors (Pty) Ltd"
                    />
                  </div>

                  {/* BANK NAME */}
                  <div className={styles.inputGroup}>
                    <label>Bank Name</label>
                    <select
                      value={beneficiaryForm.bank_name}
                      onChange={(e) =>
                        setBeneficiaryForm((s) => ({
                          ...s,
                          bank_name: e.target.value,
                        }))
                      }
                      className={styles.selectPill}
                    >
                      <option value="">Select…</option>
                      {BANKS.map((b) => (
                        <option key={b.id} value={b.id}>
                          {b.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* ACCOUNT NUMBER */}
                  <div className={styles.inputGroup}>
                    <label>Account Number</label>
                    <input
                      type="text"
                      value={beneficiaryForm.account_number}
                      onChange={(e) =>
                        setBeneficiaryForm((s) => ({
                          ...s,
                          account_number: e.target.value,
                        }))
                      }
                      className={styles.selectPill}
                      placeholder="e.g. 1234567890"
                    />
                  </div>

                  {/* ACCOUNT TYPE */}
                  <div className={styles.inputGroup}>
                    <label>Account Type</label>
                    <select
                      value={beneficiaryForm.account_type}
                      onChange={(e) =>
                        setBeneficiaryForm((s) => ({
                          ...s,
                          account_type: e.target.value,
                        }))
                      }
                      className={styles.selectPill}
                    >
                      <option value="">Select…</option>
                      {ACCOUNT_TYPE_SELECT.map((t) => (
                        <option key={t.value} value={t.value}>
                          {t.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {beneficiaryModalError && (
                <p className={styles.errorText}>{beneficiaryModalError}</p>
              )}

              <p className={styles.infoText}>
                After selecting the file
                {!hasBeneficiary ? " and completing these fields" : ""}, click{" "}
                <b>Done</b>, then press <b>Save Changes</b> on the main form.
              </p>
            </div>

            {/* FOOTER */}
            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.modalBtnPrimary}
                onClick={() => {
                  if (!bankProofFile) {
                    setBeneficiaryModalError(
                      "Please choose the bank account proof file.",
                    );
                    return;
                  }
                  if (!hasBeneficiary) {
                    if (
                      !beneficiaryForm.account_name ||
                      !beneficiaryForm.bank_name ||
                      !beneficiaryForm.account_number ||
                      !beneficiaryForm.account_type
                    ) {
                      setBeneficiaryModalError(
                        "Please complete all beneficiary fields.",
                      );
                      return;
                    }
                  }
                  setBeneficiaryModalError("");
                  setBeneficiaryModalOpen(false);
                }}
              >
                Done
              </button>
              <button
                type="button"
                className={styles.modalBtnSecondary}
                onClick={() => setBeneficiaryModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ────────── Upload Quote Modal ────────── */}
      {uploadModalOpen && (
        <div
          role="dialog"
          aria-modal="true"
          className={styles.modalOverlay}
          onClick={closeUploadModal}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            {/* HEADER */}
            <div className={styles.modalHeaderRow}>
              <h2 className={styles.modalTitle}>UPLOAD QUOTE</h2>
              <button
                type="button"
                className={styles.modalClose}
                onClick={closeUploadModal}
              >
                ✕
              </button>
            </div>

            {/* BODY */}
            <div className={styles.modalBody}>
              <div className={styles.inputGroup}>
                <label>Quote PDF</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setUploadFile(e.target.files?.[0] || null)}
                  className={styles.selectPill}
                />
                <p className={styles.infoText}>Only PDF files are accepted.</p>
              </div>

              <div className={styles.inputGroup}>
                <label>Amount</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={uploadAmount}
                  onChange={(e) => setUploadAmount(e.target.value)}
                  className={styles.selectPill}
                  placeholder="e.g. 12345.67"
                />
              </div>

              {uploadError && <p className={styles.errorText}>{uploadError}</p>}
            </div>

            {/* FOOTER */}
            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.modalBtnPrimary}
                onClick={handleUploadSave}
                disabled={uploadSubmitting}
              >
                {uploadSubmitting ? "Saving…" : "Save"}
              </button>
              <button
                type="button"
                className={styles.modalBtnSecondary}
                onClick={closeUploadModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {legalUpdateModalOpen && selectedLegal && (
        <div
          role="dialog"
          aria-modal="true"
          className={styles.modalOverlay}
          onClick={() => setLegalUpdateModalOpen(false)}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeaderRow}>
              <h2 className={styles.modalTitle}>UPDATE CASE EVENTS</h2>
              <button
                className={styles.modalClose}
                type="button"
                onClick={() => setLegalUpdateModalOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className={styles.profileButtonRow}>
              <button
                type="button"
                className={styles.profileSaveBtn}
                disabled={legalModalSaving}
                onClick={handleLegalModalSaveDetails}
              >
                {legalModalSaving ? "Saving..." : "Save Updates"}
              </button>
            </div>

            <div className={styles.modalBody}>
              <p className={styles.infoText}>
                {Array.isArray(selectedLegal)
                  ? `${selectedLegal.length} legal files selected`
                  : selectedLegal.cj_name || selectedLegal.name || "Legal file"}
              </p>
              <div className={styles.inputGroup}>
                <label>
                  Current Situation
                  {Array.isArray(selectedLegal)
                    ? " - applies to all selected files"
                    : ""}
                </label>

                <textarea
                  className={styles.selectPill}
                  rows={5}
                  value={legalEditFields.current_situation}
                  onChange={(e) =>
                    setLegalEditFields((s) => ({
                      ...s,
                      current_situation: e.target.value,
                    }))
                  }
                  placeholder="Update the current situation..."
                />
              </div>

              {shouldShowField(legalEditFields.letter_of_demand) && (
                <div className={styles.inputGroup}>
                  <label>Letter of Demand</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.letter_of_demand}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        letter_of_demand: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.summons_sent_to_court) && (
                <div className={styles.inputGroup}>
                  <label>Summons Sent To Court</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.summons_sent_to_court}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        summons_sent_to_court: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.summons_served) && (
                <div className={styles.inputGroup}>
                  <label>Summons Served</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.summons_served}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        summons_served: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.judgement) && (
                <div className={styles.inputGroup}>
                  <label>Judgement</label>
                  <select
                    className={styles.selectPill}
                    value={legalEditFields.judgement}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        judgement: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select…</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              )}

              {shouldShowField(legalEditFields.judgement_granted) && (
                <div className={styles.inputGroup}>
                  <label>Judgement Granted</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.judgement_granted}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        judgement_granted: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.warrant_of_execution) && (
                <div className={styles.inputGroup}>
                  <label>Warrant of Execution</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.warrant_of_execution}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        warrant_of_execution: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.nulla_bonna) && (
                <div className={styles.inputGroup}>
                  <label>Nulla Bonna</label>
                  <select
                    className={styles.selectPill}
                    value={legalEditFields.nulla_bonna}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        nulla_bonna: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select…</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              )}

              {shouldShowField(legalEditFields.attachment) && (
                <div className={styles.inputGroup}>
                  <label>Attachment</label>
                  <select
                    className={styles.selectPill}
                    value={legalEditFields.attachment}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        attachment: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select…</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              )}

              {shouldShowField(legalEditFields.rule46_application) && (
                <div className={styles.inputGroup}>
                  <label>Rule 46 Application</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.rule46_application}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        rule46_application: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.section65) && (
                <div className={styles.inputGroup}>
                  <label>Section 65</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.section65}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        section65: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {shouldShowField(legalEditFields.section66) && (
                <div className={styles.inputGroup}>
                  <label>Section 66</label>
                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalEditFields.section66}
                    onChange={(e) =>
                      setLegalEditFields((s) => ({
                        ...s,
                        section66: e.target.value,
                      }))
                    }
                  />
                </div>
              )}
              {legalModalError && (
                <p className={styles.errorText}>{legalModalError}</p>
              )}
              {legalModalSuccess && (
                <p className={styles.successText}>{legalModalSuccess}</p>
              )}
            </div>
          </div>
        </div>
      )}

      {legalPaymentModalOpen && selectedLegal && (
        <div
          role="dialog"
          aria-modal="true"
          className={styles.modalOverlay}
          onClick={() => setLegalPaymentModalOpen(false)}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeaderRow}>
              <h2 className={styles.modalTitle}>
                LOAD LEGAL {legalSubmissionLabel.toUpperCase()}
              </h2>
              <button
                className={styles.modalClose}
                type="button"
                onClick={() => setLegalPaymentModalOpen(false)}
              >
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <p className={styles.infoText}>
                {Array.isArray(selectedLegal)
                  ? `${selectedLegal.length} legal files selected`
                  : selectedLegal.cj_name || selectedLegal.name || "Legal file"}
              </p>

              <div className={styles.inputGroup}>
                <label>{legalSubmissionLabel} File</label>
                <input
                  type="file"
                  className={styles.selectPill}
                  onChange={(e) =>
                    setLegalPaymentForm((s) => ({
                      ...s,
                      file: e.target.files?.[0] || null,
                    }))
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Amount</label>
                <input
                  type="number"
                  className={styles.selectPill}
                  value={legalPaymentForm.amount}
                  onChange={(e) =>
                    setLegalPaymentForm((s) => ({
                      ...s,
                      amount: e.target.value,
                    }))
                  }
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Supplier Invoice Number</label>
                <input
                  type="text"
                  className={styles.selectPill}
                  value={legalPaymentForm.invoice}
                  onChange={(e) =>
                    setLegalPaymentForm((s) => ({
                      ...s,
                      invoice: e.target.value,
                    }))
                  }
                />
              </div>

              {hasInvoiceSubmissionRows && (
                <div className={styles.inputGroup}>
                  <label>Inv Date</label>

                  <input
                    type="date"
                    className={styles.selectPill}
                    value={legalPaymentForm.invoiceDate}
                    onChange={(e) =>
                      setLegalPaymentForm((current) => ({
                        ...current,
                        invoiceDate: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              <div className={styles.profileButtonRow}>
                <button
                  type="button"
                  className={styles.profileSaveBtn}
                  disabled={legalModalSaving}
                  onClick={handleLegalModalSubmitPayment}
                >
                  {legalModalSaving
                    ? "Loading..."
                    : `Load ${legalSubmissionLabel}`}
                </button>
              </div>

              {legalModalError && (
                <p className={styles.errorText}>{legalModalError}</p>
              )}
              {legalModalSuccess && (
                <p className={styles.successText}>{legalModalSuccess}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
